import LocationSelector from './LocationSelectorContainer';

export default LocationSelector

